import React from 'react';
import messages from '../../locale/messages';
import WhyHostView from './WhyHostView';
import WhyHostLayout from '../../components/Layout/WhyHostLayout';

export default function action({ intl }) {

  const title = intl?.formatMessage(messages.becomeAHost);


  return {
    title,
    component: <WhyHostLayout>
      <WhyHostView title={title} />
    </WhyHostLayout>
  };
}
